import styled from "styled-components"

import { SPACING } from "../component-library/design/spacing/spacing.constants"
import { ClassicRadioButton } from "../component-library/components/classic-radio-button/classic-radio-button.component"

const SelectPaymentMethodWrapper = styled.div``

const StyledClassicRadioButton = styled(ClassicRadioButton)`
  margin-bottom: ${SPACING.XS};
`

const RadioOptionGroup = styled.div`
  margin-bottom: ${SPACING.S};

  &:last-of-type {
    margin-bottom: 0;
  }
`

export {
  SelectPaymentMethodWrapper,
  StyledClassicRadioButton,
  RadioOptionGroup,
}
